<ng-container *ngIf="(mobileSelectedFacetData$ | async | keyvalue)?.length">
  <ng-container
    *ngFor="let item of mobileSelectedFacetData$ | async | keyvalue">
    <a
      (keydown.space)="removeFromMobileSelectedFacet(item.key, val)"
      (click)="removeFromMobileSelectedFacet(item.key, val)"
      *ngFor="let val of item.value"
      tabindex="0"
      class="mb-2 active-facet w-auto"
      data-cy="activeFacet"
      role="button">
      <rrs-filter-tag
        [closeable]="true"
        [name]="
          isSizeFacet(item) ? (getTranslationKey(item.key) | cxTranslate) : ''
        "
        [option]="val | uppercase"></rrs-filter-tag>
    </a>
  </ng-container>
</ng-container>
